export class DocumentFilter {
    public  countryId :number;
    public  productTypeId :number;
    public  productSubTypeId : number;
    public productId: number;
    public purchasedate: string;
    public fileName: string;
    public email: string;
    public  documentId : number
}
